/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectStopReschedulingDtoBase
 * auto generated base class for the model ProjectStopReschedulingDtoModel.
 *
 * Stop rescheduling
 */
export const ProjectStopReschedulingDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectStopReschedulingDto')
  .props({
    __typename: types.optional(types.literal("ProjectStopReschedulingDto"), "ProjectStopReschedulingDto"),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectStopReschedulingDtoModelSelector extends QueryBuilder {
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectStopReschedulingDto() {
  return new ProjectStopReschedulingDtoModelSelector()
}

export const projectStopReschedulingDtoModelPrimitives = selectFromProjectStopReschedulingDto()
